export default {"src":"/_next/static/media/enerflo-platform-icon-most-integrations.8921f700.svg","height":160,"width":160};